//@ts-nocheck
//@ts-ignore
/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { useStore } from '../../store/store';
import { useNav } from '../../hooks/nav';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';
import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';
import Button from 'src/onboarding/components/ui/button/Button';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import { Text } from 'src/onboarding/components/typography/Text/Text';
import { Check } from 'src/onboarding/components/ui/check/Check';
import { Option } from 'src/onboarding/components/ui/check/Option';
import cn from 'classnames';
import styles from './style.module.scss';
import crispBread from '../../assets/images/crispBread.webp';
import sweetFries from '../../assets/images/sweetFries.webp';
import healthyBurrito from '../../assets/images/healthyBurrito.webp';
import toast from '../../assets/images/toast.webp';
import fries from '../../assets/images/fries.webp';
import burrito from '../../assets/images/burrito.webp';
import { Caption } from 'src/onboarding/components/typography/Caption/Caption';

function Page() {
  const youGuessedCount = useStore((state) => state.youGuessedCount);

  const { onNext, currentIndex } = useNav();
  const leftMenuItems = [
    { src: crispBread, alt: 'crisp bread' },
    { src: sweetFries, alt: 'fries' },
    { src: healthyBurrito, alt: 'burrito' },
  ];

  const rightMenuItems = [
    { src: toast, alt: 'toast' },
    { src: fries, alt: 'fries' },
    { src: burrito, alt: 'burrito' },
  ];

  return (
    <div className='page' style={{ paddingBottom: '90px' }}>
      <div className='wrapper-info' style={{ gap: '20px' }}>
        <Title tag='h2'>{t('onboarding.enjoyFullPlates.title')}</Title>

        <div className={styles.menu}>
          <div className={styles.menuLeft}>
            <div className={styles.dishes}>
              {leftMenuItems.map((item, index) => (
                <div className={styles.imgWrapper} key={index}>
                  <img src={item.src} alt={item.alt} />
                </div>
              ))}
            </div>
            <Title tag='h2' className={styles.menuCalories}>
              660 kcal
            </Title>
          </div>
          <div className={styles.menuRight}>
            <div className={styles.dishes}>
              {rightMenuItems.map((item, index) => (
                <div className={styles.imgWrapper} key={index}>
                  <img src={item.src} alt={item.alt} />
                </div>
              ))}
            </div>
            <Title tag='h2' className={styles.menuCalories}>
              1820 kcal
            </Title>
          </div>
        </div>
        <div className={styles.message}>
          <Text size='m' medium>
            {t('onboarding.enjoyFullPlates.message.start')} 🎯
          </Text>
          <Text size='m' medium>
            {t('onboarding.enjoyFullPlates.message.end')}
          </Text>
        </div>
      </div>
      <div className={'overlay'}></div>
      <div className={'next-wrapper'}>
        <Button
          title={t('onboarding.enjoyFullPlates.continue')}
          onClick={() => {
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'enjoy-full-plates',
            });
            onNext();
          }}
        />
      </div>
    </div>
  );
}

export default Page;
